// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keLpyu0oBV_6RvSaQvdj{
    padding: 20px 270px;
    background-color: #F5F5F5;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}
.W5ZpT3zmRqVnlls4xjQW{
    margin-top: -5px;
    font-size: 20px;
    padding: 10px 0;
}
.HuQzQeRb3SFkWUPIIa6D{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    align-items: center;
}
.vvenBUBFZdIAlCAHtwEh {
    margin: 10px auto 0 auto;
    background-color: white;
    height: 40px;
    width: 960px;
    border-radius: 12px;
}
.n2d3cLQzyIPPVVH80Njd{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.rd0TGH3JaPkEzcEVchp7{
    height: 65vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 20px;
}
.LDrZJj1PFdTLFJU_1T4K{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.HcvZ9_fJcHVB4POz7yOq{
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.AxUQetwBwtFiy1nsFuNq{
    padding: 5px 10px;
    background-color: white;
    border-radius: 10px;
    cursor: pointer;
}
.HRCXZ1B4fvGn4V3cE1FC {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}
.AFQOiKMVXqN8UFqEiMCR {
    font-size: 12px;
    color: #888;
    line-height: 1.2;
}
.aIVnsGBIjQnNKJ2urPkG {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}
.twkvZJaS07Hc99TOdUPD,.e5JYbVNpKML3xQdicrcE {
    display: flex;
    padding: 7px 5px;
    font-size: 10px;
    align-items: center;
    justify-content: center;
    width: 60px;
    background-color: #004BA0;
    height: 10px;
    border: none;
    color: white;
    border-radius: 20px;
    cursor: pointer;
}
.mIHU0qY3_d6YzVl_dt1s{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.gdDertKA2rWA1dY0kAsJ{
    background-color: #F5F5F5;
    border-radius: 10px;
    padding: 0 10px;
}
.LoUaL9wWY475ZlALKiaL {
    display: flex;
    gap: 5px;
    border: none;
    color: #555;
    cursor: pointer;
}
.bsWVTyrg46LqMQ2Lwimi, .LoUaL9wWY475ZlALKiaL {
    background-color: #f0f0f0;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    color: #555;
}

._tfJAVl6LEQG2oMXH_4E {
    position: absolute;
    top: 50%;
    left: 50%;
}

/*mobile view*/

@media Screen and (max-width: 600px) {
    .yRtdZinV7oluRqSeJmsi {
        padding: 0 20px 20px 20px;
        background-color: #f5f5f5;
        min-height: 100vh;
    }

    .RQ70Pgnbxuajx9R2t6E9{
        font-size: 27px;
        font-family: "Nunito Sans", sans-serif;
        font-weight: bold;
        margin-top: -12%;
        margin-left: 13px;

    }
    .Z9FYDpCNjzHtdPkapHLy {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    ._RWPwK5V4zVSrZrslD8j{
        position: absolute;
        top: 60%;
        left: 40%;
        transform: translate(-50%, -50%);
    }

    .AxUQetwBwtFiy1nsFuNq {
        padding: 20px;
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .zotiDjPKreTDuLoMInLW {
        font-size: 18px;
        font-weight: bold;
        color: rgba(0, 75, 160, 1);;
        margin: 0 0 10px 0;
    }



    .wjuawT9OTGUc8g731xsE {
        font-size: 16px;
        color:  rgba(77, 77, 77, 1);
        line-height: 1.6;
        margin: 0 0 10px 0;
    }

    .tW9fmmEuuP5bhcAUZwit {
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
    }

    .Vs4po8BI4Wni1ZUZKQqm {
        margin-top: 15px;
    }

    .Vs4po8BI4Wni1ZUZKQqm h4 {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
    }

    .gdDertKA2rWA1dY0kAsJ {
        margin-bottom: 15px;
        padding: 10px;
        background-color: #f9f9f9;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .Y7XItXiJbqsrW7ql2gRF {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #888;
    }

    .E3tGyglCaun3AePf92go {
        display: flex;
        gap: 10px;
        margin-right: 50%;

    }

    .E3tGyglCaun3AePf92go img {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }



    .J8DxlTJD8l8IwI_LRzMn p {
        font-size: 14px;
        color: #333;
        margin-top: 10px;
        line-height: 1.6;
    }

    .q8tioGC7KJdD3iPXuAc7 {
        text-align: center;
        color: #999;
        font-size: 16px;
    }

    .dBGPm3cZmB6oHNcC07om {
        background-color: white;
        width: 97%;
        border-radius: 20px;
        padding: 10px;
        margin-bottom: 20px;
    }

    .fhExK2Q1OrkKkIbKaQkD {
        font-size: 16px;
        color: white;
        background-color: #1976d2;
        padding: 10px 15px;
        border: none;
        border-radius: 20px;
        cursor: pointer;
        text-align: center;
        display: inline-block;
    }

    .fhExK2Q1OrkKkIbKaQkD:hover {
        background-color: #135ba0;
    }

    .jAmB914sZFqlg00iFHEa {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        margin-top: 36%;

    }

    .MApXTuCirQ7GO3XBJ7dj {
        width: 80px;
        height: 80px;
        margin-bottom: 15px;
        opacity: 0.8;
    }

    .OVus5HZll3dwdSmCasra {
        font-size: 16px;
        color:rgba(142, 142, 142, 1);
        text-align: center;
        line-height: 1.5;
    }

}`, "",{"version":3,"sources":["webpack://./src/home/css/community-my-answers-detailed.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA,cAAc;;AAEd;IACI;QACI,yBAAyB;QACzB,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,sCAAsC;QACtC,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;;IAErB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;IACpC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,wCAAwC;IAC5C;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,0BAA0B;QAC1B,kBAAkB;IACtB;;;;IAIA;QACI,eAAe;QACf,2BAA2B;QAC3B,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,yBAAyB;QACzB,kBAAkB;QAClB,wCAAwC;IAC5C;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;QACb,SAAS;QACT,iBAAiB;;IAErB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;;;IAIA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,UAAU;QACV,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,eAAe;;IAEnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,4BAA4B;QAC5B,kBAAkB;QAClB,gBAAgB;IACpB;;AAEJ","sourcesContent":[".answerDetailedMain{\n    padding: 20px 270px;\n    background-color: #F5F5F5;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n.myans{\n    margin-top: -5px;\n    font-size: 20px;\n    padding: 10px 0;\n}\n.myansContainer{\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n    align-items: center;\n}\n.searchWrapper {\n    margin: 10px auto 0 auto;\n    background-color: white;\n    height: 40px;\n    width: 960px;\n    border-radius: 12px;\n}\n.loader{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.noAnswers{\n    height: 65vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    font-size: 20px;\n}\n.questionTitle{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.questionsContainer{\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.questionItem{\n    padding: 5px 10px;\n    background-color: white;\n    border-radius: 10px;\n    cursor: pointer;\n}\n.dateContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n.answerDetailedDate {\n    font-size: 12px;\n    color: #888;\n    line-height: 1.2;\n}\n.editDeleteButtons {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n.editButton,.deleteButton {\n    display: flex;\n    padding: 7px 5px;\n    font-size: 10px;\n    align-items: center;\n    justify-content: center;\n    width: 60px;\n    background-color: #004BA0;\n    height: 10px;\n    border: none;\n    color: white;\n    border-radius: 20px;\n    cursor: pointer;\n}\n.answerContainer{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.answerItem{\n    background-color: #F5F5F5;\n    border-radius: 10px;\n    padding: 0 10px;\n}\n.copyLinkButton {\n    display: flex;\n    gap: 5px;\n    border: none;\n    color: #555;\n    cursor: pointer;\n}\n.answerCount, .copyLinkButton {\n    background-color: #f0f0f0;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    color: #555;\n}\n\n.loadQuestions {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n}\n\n/*mobile view*/\n\n@media Screen and (max-width: 600px) {\n    .myAnswerContainer {\n        padding: 0 20px 20px 20px;\n        background-color: #f5f5f5;\n        min-height: 100vh;\n    }\n\n    .answersDetailedHead{\n        font-size: 27px;\n        font-family: \"Nunito Sans\", sans-serif;\n        font-weight: bold;\n        margin-top: -12%;\n        margin-left: 13px;\n\n    }\n    .questionList {\n        margin-top: 20px;\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n    }\n\n    .mobileLoader{\n        position: absolute;\n        top: 60%;\n        left: 40%;\n        transform: translate(-50%, -50%);\n    }\n\n    .questionItem {\n        padding: 20px;\n        background-color: #fff;\n        border-radius: 12px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n\n    .questionHead {\n        font-size: 18px;\n        font-weight: bold;\n        color: rgba(0, 75, 160, 1);;\n        margin: 0 0 10px 0;\n    }\n\n\n\n    .questionDesc {\n        font-size: 16px;\n        color:  rgba(77, 77, 77, 1);\n        line-height: 1.6;\n        margin: 0 0 10px 0;\n    }\n\n    .addAnswerButton {\n        margin-top: 10px;\n        display: flex;\n        justify-content: flex-start;\n    }\n\n    .userAnswers {\n        margin-top: 15px;\n    }\n\n    .userAnswers h4 {\n        font-size: 16px;\n        font-weight: bold;\n        color: #333;\n        margin-bottom: 10px;\n    }\n\n    .answerItem {\n        margin-bottom: 15px;\n        padding: 10px;\n        background-color: #f9f9f9;\n        border-radius: 8px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    }\n\n    .answerHeader {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 14px;\n        color: #888;\n    }\n\n    .answerActions {\n        display: flex;\n        gap: 10px;\n        margin-right: 50%;\n\n    }\n\n    .answerActions img {\n        width: 20px;\n        height: 20px;\n        cursor: pointer;\n    }\n\n\n\n    .answerContent p {\n        font-size: 14px;\n        color: #333;\n        margin-top: 10px;\n        line-height: 1.6;\n    }\n\n    .noQuestions {\n        text-align: center;\n        color: #999;\n        font-size: 16px;\n    }\n\n    .searchContainer {\n        background-color: white;\n        width: 97%;\n        border-radius: 20px;\n        padding: 10px;\n        margin-bottom: 20px;\n    }\n\n    .actionButtonContainer {\n        font-size: 16px;\n        color: white;\n        background-color: #1976d2;\n        padding: 10px 15px;\n        border: none;\n        border-radius: 20px;\n        cursor: pointer;\n        text-align: center;\n        display: inline-block;\n    }\n\n    .actionButtonContainer:hover {\n        background-color: #135ba0;\n    }\n\n    .noAnswersContainer {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding: 20px;\n        margin-top: 36%;\n\n    }\n\n    .noAnsIcon {\n        width: 80px;\n        height: 80px;\n        margin-bottom: 15px;\n        opacity: 0.8;\n    }\n\n    .noAnswersText {\n        font-size: 16px;\n        color:rgba(142, 142, 142, 1);\n        text-align: center;\n        line-height: 1.5;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"answerDetailedMain": `keLpyu0oBV_6RvSaQvdj`,
	"myans": `W5ZpT3zmRqVnlls4xjQW`,
	"myansContainer": `HuQzQeRb3SFkWUPIIa6D`,
	"searchWrapper": `vvenBUBFZdIAlCAHtwEh`,
	"loader": `n2d3cLQzyIPPVVH80Njd`,
	"noAnswers": `rd0TGH3JaPkEzcEVchp7`,
	"questionTitle": `LDrZJj1PFdTLFJU_1T4K`,
	"questionsContainer": `HcvZ9_fJcHVB4POz7yOq`,
	"questionItem": `AxUQetwBwtFiy1nsFuNq`,
	"dateContainer": `HRCXZ1B4fvGn4V3cE1FC`,
	"answerDetailedDate": `AFQOiKMVXqN8UFqEiMCR`,
	"editDeleteButtons": `aIVnsGBIjQnNKJ2urPkG`,
	"editButton": `twkvZJaS07Hc99TOdUPD`,
	"deleteButton": `e5JYbVNpKML3xQdicrcE`,
	"answerContainer": `mIHU0qY3_d6YzVl_dt1s`,
	"answerItem": `gdDertKA2rWA1dY0kAsJ`,
	"copyLinkButton": `LoUaL9wWY475ZlALKiaL`,
	"answerCount": `bsWVTyrg46LqMQ2Lwimi`,
	"loadQuestions": `_tfJAVl6LEQG2oMXH_4E`,
	"myAnswerContainer": `yRtdZinV7oluRqSeJmsi`,
	"answersDetailedHead": `RQ70Pgnbxuajx9R2t6E9`,
	"questionList": `Z9FYDpCNjzHtdPkapHLy`,
	"mobileLoader": `_RWPwK5V4zVSrZrslD8j`,
	"questionHead": `zotiDjPKreTDuLoMInLW`,
	"questionDesc": `wjuawT9OTGUc8g731xsE`,
	"addAnswerButton": `tW9fmmEuuP5bhcAUZwit`,
	"userAnswers": `Vs4po8BI4Wni1ZUZKQqm`,
	"answerHeader": `Y7XItXiJbqsrW7ql2gRF`,
	"answerActions": `E3tGyglCaun3AePf92go`,
	"answerContent": `J8DxlTJD8l8IwI_LRzMn`,
	"noQuestions": `q8tioGC7KJdD3iPXuAc7`,
	"searchContainer": `dBGPm3cZmB6oHNcC07om`,
	"actionButtonContainer": `fhExK2Q1OrkKkIbKaQkD`,
	"noAnswersContainer": `jAmB914sZFqlg00iFHEa`,
	"noAnsIcon": `MApXTuCirQ7GO3XBJ7dj`,
	"noAnswersText": `OVus5HZll3dwdSmCasra`
};
export default ___CSS_LOADER_EXPORT___;
